
<template>
  <div class="df-frontend-tag" v-if="tags && tags.length > 0">
    <div 
      :class="[
        'df-frontend-tag-tags-content',
        isWrap ? '' : 'df-frontend-tag-tags-head',
        isOnlyLine ? 'df-frontend-tag-one-tag' : '',
      ]"
    >
      <span
        v-for="(tagItem, index) in tags"
        :key="index"
        class="df-frontend-tag-tags-content-item"
      >
        <!-- 优惠券 -->
        <div v-if="tagItem.mktFrontType == 400001 && tagItem.mktText">
          <div class="coupon-tag clearfix">
            <span class="coupon-tag-icon fl">券</span>
            <div class="coupon-tag-info">{{getText(tagItem)}}</div>
          </div>
        </div>
        <!-- 运营图片 -->
        <img
          :src="tagItem.mktIcon"
          alt=""
          v-else-if="tagItem.mktIcon && constant.priorityList.includes(tagItem.mktFrontType || 0)"
          :style="tagItem.style"
          :class="['df-frontend-tag-image']"
        />
        <!-- 营销标签 -->
        <span
          v-else
          :class="[
            'df-frontend-tag-single-tag',
            `tag${tagItem.mktFrontType}`,
          ]"
          :style="getCss(tagItem)"
        >{{getText(tagItem)}}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "FrontendTag",
  props: {
    tags: {
      type: Array,
      default: () =>[],
    },
    // 默认文字与标签同行展示
    isWrap: {
      type: Boolean,
      default: false,
    },
    // 默认标签可多行展示
    isOnlyLine: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mockTags:[
        // {
        //   mktFrontType: 9001,
        //   mktText: '新品',
        //   mktIcon:
        //     'http://devimg.dongfangfuli.com/mall/upload/image_temp/2020-12/0bc63bd7-d5c8-4383-a0f7-66020d7af8cd.png',
        // },
        // { mktFrontType: 9004, mktText: '起购标签' },
        // {
        //   mktFrontType: 9005,
        //   mktText: '起购标签胡歌要刮台风台风天的人打扰的堵塞huhhhh不会v个v个hugygybhffu个衣服太丰富',
        //   fontColor: 'white',
        //   backgroundColor: '#ff5757',
        // },

        { mktFrontType: 9001, mktText: '新品标签' },
        // { mktFrontType: 9006, mktText: '年货节年货节' },
        // { mktFrontType: 300001, mktText: '满40-20' },

        {
          mktFrontType: 9006,
          mktText: '图片',
          mktIcon: 'https://devimg.dongfangfuli.com/mall/upload/image_temp/2023-03/f02229c4-f067-44d1-ab3a-9aa0706bf4eb.jpg',
        },
        // {
        //   mktFrontType: 9005,
        //   mktText: '频道标签',
        //   fontColor: 'white',
        //   backgroundColor: '#ff5757',
        // },
        // { mktFrontType: 9004, mktText: '起购标签' },
        // { mktFrontType: 9001, mktText: '新品标签' },
        // { mktFrontType: 9006, mktText: '年货节' },
        // { mktFrontType: 300001, mktText: '满40-20' },

        // {
        //   mktFrontType: TagType.IMAGE,
        //   mktText: '图片2',
        //   mktIcon: 'https://www.baidu.com/img/PCtm_d9c8750bed0b3c7d089fa7d55720d6cf.png',
        // },
      ]
    };
  },
  methods: {
    getCss(val) {
      if (!val) {
        return null;
      }
      const type = Number(val.mktFrontType);
      let cssJson = { ...val.style };
      if (type) {
        switch(type){
          case 1001: // 特价
          case 1004: // 抢购
          case 9001: // 新品
          case 2001: // 满减
          case 9003: // 限购
          case 9004: // 起购
          case 300001: // 抽奖
            break;
          case 9005: // 频道名称
          case 9006: // 运营标签
          case 90061: // 运营标签
          case 90062: // 运营标签
          case 9007: // 体检自营标签
            cssJson = { color: val.fontColor, background: val.backgroundColor, ...cssJson };
            break;
        }
      } else if (val.name) {
        cssJson = { color: '#FF6600', border: '1px solid #FF6600', ...cssJson };
      }
      return cssJson;
    },
    getText(val) {
      if (!val) {
        return null;
      }
      const type = Number(val.mktFrontType);
      let str = "";
      if (type) {
        switch(type){
          case 1001: // 特价
            str = "特价";
            break;
          case 1004: // 抢购
            str = "抢购";
            break;
          case 9001: // 新品
            str = "新品";
            break;
          case 2001: // 满减
            str = "满减";
            break;
          case 9003: // 限购
            str = val.mktText;
            break;
          case 9004: // 起购
            str = val.mktText;
            break;
          case 9005: // 频道名称
            str = val.mktText;
            break;
          case 9006: // 运营标签
            str = val.mktText;
            break;
          case 90061: // 运营标签
            str = val.mktText;
            break;
          case 90062: // 运营标签
            str = val.mktText;
            break;
          case 9007: // 体检自营标签
            str = val.mktText;
            break;
          case 300001: // 抽奖
            str = "抽奖";
            break;
        }
      } else if (val.name) {
        str = val.name;
      }
      return this.TLang(str, "cart");
    },
  },
};
</script>

<style lang="less" scoped>
@375: 320/375;
.df {
  &-frontend-tag {
    // display: -webkit-box;
    width: auto;
    max-width: 100%;
    overflow: hidden;
    // display: inline-flex;
    display: inline-block;
    // position: relative;
    // top: 1px;
    // display: -webkit-inline-box;
    // text-overflow: ellipsis;
    // -webkit-box-orient: vertical;
    // -webkit-line-clamp: 1;
    &-one-tag {
      max-height: 20px * @375;
    }
    &-tags-content {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      overflow: hidden;
      // width: 100%;
      // max-height: 16px * @375;
      &-item {
        max-width: 100%;
        margin-right: 4px * @375;
        // margin-bottom: 4px * @375;
        align-self: center;
        flex-shrink: 1;
        overflow: hidden;
        &:first-child {
          flex-shrink: 0;
        }
      }
    }
    &-tags-head {
      flex-wrap: nowrap;
      width: 100%;
      // height: 24px * @375;
    }
    &-image {
      display: block;
      // max-width: 57px * @375;
      height: 14px * @375;
      // line-height: 14px * @375;
      // vertical-align: middle;
    }
    &-single-tag {
      // display: block;
      display: -webkit-box !important;
      width: auto;
      padding: 0 2px * @375;
      height: 16px * @375;
      border-radius: 2px * @375;
      line-height: 16px * @375;
      box-sizing: border-box;
      text-align: center;
      font-size: 12px * @375;
      margin-top: 0;
      color: #FF6600;
      border: 1px * @375 solid #FF6600;
      // .ellipsis();
      white-space: normal;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      word-break: break-all;
      
    }
    .tag1001 {
      color: #FF6600;
      border: 1px * @375 solid #FF6600;
      padding: 0 2px * @375;
    }
    .tag1004 {
      color: #FF6600;
      border: 1px * @375 solid #FF6600;
      padding: 0 2px * @375;
    }
    .tag9001 {
      color: #56CC08;
      border: 1px * @375 solid #56CC08;
      padding: 0 2px * @375;
    }
    .tag2001 {
      color: #FF6600;
      border: 1px * @375 solid #FF6600;
      padding: 0 2px * @375;
    }
    .tag9003,
    .tag9004 {
      width: auto;
      height: 16px * @375;
      line-height: 16px * @375;
      color: #A037E5;
      border: solid 1px #A037E5;
      padding: 0 2px * @375;
    }
    .tag9005,
    .tag9006 {
      // display: inline-block;
      width: auto;
      height: 14px * @375;
      line-height: 15px * @375;
      // height: auto;
      // line-height: 1;
      border: none;
      border-radius: 2px * @375;
      font-size: 10px * @375;
      font-weight: 400;
      // margin-right: 4px * @375;
      padding: 0 2px * @375 0;
      max-width: 100%;
      text-align: left;
    }
    //
    .tag300001 {
      color: #FF6600;
      border: 1px solid #FF6600;
      padding: 0 2px * @375;
    }
    // 奖品标签
    .tag8000005 {
      display: inline-block;
      width: auto;
      height: auto;
      line-height: 10px * @375;
      border-radius: 2px * @375;
      font-size: 10px * @375;
      font-weight: 500;
      // margin-right: 3px * @375;
      padding: 2px * @375 1px * @375;
      text-align: center;
      box-sizing: border-box;
    }
    // 抽奖标签
    .tag8000006 {
      display: inline-block;
      width: auto;
      height: 16px * @375;
      border-radius: 2px * @375;
      line-height: 16px * @375;
      box-sizing: border-box;
      font-size: 12px * @375;
      font-weight: 400;
      // margin-right: 3px * @375;
      padding: 0 2px * @375;
      color: #FF6600;
      border: 1px solid #FF6600;
      span {
          font-size: 12px * @375;
      }
    }

    /************** 优惠劵 **************/
    .coupon-tag {
      display: flex;
      & > img {
        width: 18px * @375 !important;
        height: 16px * @375 !important;
        vertical-align: super;
      }
      .coupon-tag-icon {
        box-sizing: border-box;
        width: 16px * @375;
        height: 16px * @375;
        color: #ffffff;
        font-weight: 400;
        font-size: 12px * @375;
        line-height: 15.5px * @375;
        text-align: center;
        background: #ff6600;
        border: 1px #ff6600 solid;
        border-radius: 2px * @375 0px 0px 2px * @375;
      }
      .coupon-tag-info {
        // max-width: calc(100%-20px) !important;
        box-sizing: border-box;

        height: 16px * @375 !important;
        padding: 0px 2px * @375 !important;
        overflow: hidden;
        color: #ff6600;
        font-weight: 500 !important;
        font-size: 12px * @375 !important;
        line-height: 16px * @375 !important;
        white-space: nowrap;
        text-overflow: ellipsis;
        border: 1px #ff6600 solid;
        border-left: 0px * @375;
        border-top-right-radius: 2px * @375;
        border-bottom-right-radius: 2px * @375;
      }
    }
  }
}
.clearfix {
  zoom: 1;
}
.clearfix:after {
  content: " ";
  display: block;
  height: 0;
  font-size: 0;
  clear: both;
  visibility: hidden;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
</style>